/**
 * @desc 产品标签分页
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: API.omsFlow.mskuMap.productLabelPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/mskuMap/productLabelPage`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
